import type { Analysis } from "../../../../api/Analysis";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";

export const getAnalysesIncludedInReporting = (analyses: (Analysis | ActiveAnalysis)[]) =>
  analyses.reduce<{
    analysesIncludedInReporting: { [id: string]: boolean };
    lastIncludedAnalysis: { year: number | null; month: number | null; id: string | null };
  }>(
    (acc, analysis) => {
      const date = new Date(analysis.date);
      const analysisMonth = date.getUTCMonth();
      const analysisYear = date.getUTCFullYear();

      if ("isPublished" in analysis && analysis.isPublished) {
        if (
          acc.lastIncludedAnalysis.month === analysisMonth &&
          acc.lastIncludedAnalysis.year === analysisYear &&
          acc.lastIncludedAnalysis.id !== null
        ) {
          acc.analysesIncludedInReporting[acc.lastIncludedAnalysis.id] = false;
        }
        acc.analysesIncludedInReporting[analysis.id] = true;
        acc.lastIncludedAnalysis.year = analysisYear;
        acc.lastIncludedAnalysis.month = analysisMonth;
        acc.lastIncludedAnalysis.id = analysis.id;
      }
      return acc;
    },
    {
      analysesIncludedInReporting: {},
      lastIncludedAnalysis: { year: null, month: null, id: null },
    },
  );
